import styled from '@emotion/styled';
import { Variables } from '../../../base/variables';
import * as Shared from '../form.styles';

// Reused from facility-form.styles.tsx
export const FormContainer = Shared.FormContainer;
export const FormGrid = styled(Shared.FormGrid)`
    grid-template-columns: repeat(3, 1fr);
`;
export const FormField = Shared.FormField;
export const Label = Shared.Label;
export const Input = Shared.Input;

